<template>
  <section>
    <v-container fluid grid-list-md>
      <!-- loading dialog -->
      <v-dialog v-model="showProgress" persistent max-width="500">
        <v-card>
          <v-card-text>
            <v-row class="fill-height" align-content="center" justify="center">
              <!-- <v-col class="text-subtitle-1 text-center" cols="12"> Getting your files </v-col> -->
              <v-col cols="6">
                <v-progress-linear
                  color="deep-purple accent-4"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- selection dialog -->
      <v-dialog v-model="showDialog" persistent max-width="320">
        <v-card>
          <v-card-title class="headline">
            <span>Scegli il CV da scaricare</span>
          </v-card-title>
          <v-card-text>
            <span>
              <v-select
                v-model="tenantName"
                :items="personalTenantsName"
                required
                :label="'Curriculum'"
              />
            </span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="showDialog = false">
              <span>Annulla</span>
            </v-btn>
            <v-btn color="error" flat @click.native="startDownload">Download</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Dialog per conferma rimozione notifiche -->
      <v-dialog v-model="showNotificationDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            <span>⚠️ {{ $t('account.notifications.modal.head') }}</span>
          </v-card-title>
          <v-card-text>
            {{ $t('account.notifications.modal.body') }}
            <br />
            <br />
            🚨 {{ $t('account.notifications.modal.body2') }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="showNotificationDialog = false">
              <span>🔄 {{ $t('account.notifications.modal.act1') }}</span>
            </v-btn>
            <v-btn color="error" flat @click.native="setNotifications(false)"
              >🔕 {{ $t('account.notifications.modal.act2') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <h2 class="name-title-size">{{ this.$t('account.my') }}</h2>
      <v-card style="max-width: fit-content" class="mt-4" variant="tonal">
        <v-card-text>
          <div class="flex">
            <v-avatar> <img :src="$user.picture" /> </v-avatar>
            <span class="ml-3">
              <b>{{ $user.name }}</b>
              <br />
              {{ $user.email }}
            </span>
          </div>
        </v-card-text>
      </v-card>
      <v-form class="mt-4">
        <!-- <div class="mb-4 mt-4">
          <v-expansion-panel>
            <v-expansion-panel-content>
              <template v-slot:header>
                <div class="d-flex">
                  {{ $t('account.notifications.title') }}
                  <div class="flex ml-4 align-center">
                    <v-badge class="d-inline" color="error">
                      <template v-slot:badge>
                        <span>{{ userNotifications.length }}</span>
                      </template>
                    </v-badge>
                  </div>
                </div>
              </template>
              <v-list subheader class="ma-4">
                <div class="flex flex-wrap justify-space-evenly">
                  <div class="f-grow-1" v-for="(notification) in userNotifications" :key="notification._id">
                    <notification-card @deleteNews="deleteNotification(notification, 0)" :time="notification.time" :name="notification.media_name" :consumer="notification.consumer" :news="notification.news_title" :imgurl="notification.imgurl"></notification-card>
                  </div>
                </div>
                <v-btn
                  v-if="userNotifications.length > 1"
                  color="error"
                  class="ml-0 mt-5"
                  @click="deleteNotification(null, 1)"
                  >{{ $t('account.notifications.deleteAll') }}</v-btn
                >
                <v-btn
                  v-if="notificationsDisabled"
                  outline
                  color="error"
                  class="ml-0 mt-5"
                  @click="toggleNotificationsDialog()"
                  >{{ $t('account.notifications.off') }}</v-btn
                >
                <v-btn v-else outline color="success" class="ml-0 mt-5" @click="setNotifications(true)"
                  >{{ $t('account.notifications.on') }}</v-btn
                >
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div> -->
        <div v-if="userTheme != 'musei'" class="white white-box">
          <div class="font-subtitle">{{ this.$t('account.choose') }}</div>
          <div class="language-switch">
            <span class="label-it">IT</span>
            <div class="switch-container">
              <v-switch v-model="selectedLanguage" @change="toggleLanguage"></v-switch>
            </div>
            <span class="label-en">EN</span>
          </div>
        </div>
        <div v-if="userTheme != 'musei'" class="ma-4">
          <div class="mb-2 font-subtitle">
            {{ this.$t('account.question') }}
          </div>
          <v-btn color="primary" class="ml-0" @click="downloadCV">{{
            this.$t('account.btn1')
          }}</v-btn>
        </div>
        <div class="white white-box">
          <div class="paragraph font-subtitle">{{ this.$t('account.exit') }} {{ platform }}</div>
          <v-btn color="error" class="ml-0" to="/logout">{{ this.$t('account.signout') }}</v-btn>
        </div>
      </v-form>
    </v-container>
  </section>
</template>

<script>
import { $EventBus } from '@/eventBus';
import axios from 'axios';
import _ from 'lodash';
//import NotificationCard from './NotificationCard.vue';

export default {
  components: {
    //NotificationCard,
  },
  data() {
    return {
      selectedLanguage: false,
      showProgress: false,
      showDialog: false,
      allTenants: null,
      personalTenantsName: [],
      personalTenants: [],
      tenantName: null,
      showNotificationDialog: false,
    };
  },
  computed: {
    userTheme() {
      return this.$store.state.user.userTheme;
    },
    platform() {
      return window.location.href.split('/')[2];
    },
    isAdmin() {
      if (this.$userHasRoles(['admin'])) return true;
      else return false;
    },
    userNotifications() {
      return this.$store.state.user.user_notifications;
    },
    notificationsDisabled() {
      return this.$store.state.user.user_toggle_notifications;
    },
  },
  mounted() {
    this.selectedLanguage = this.$i18n.locale == 'en' ? true : false;
    this.$http.get('/tenants/me').then((response) => {
      this.allTenants = response.data.items;
    });
    this.$log(this.$user);
  },
  methods: {
    toggleNotificationsDialog() {
      this.showNotificationDialog = !this.showNotificationDialog;
    },
    setNotifications(value) {
      this.$http
        .get('/users/email/' + this.$user.email)
        .then((response) => {
          const user = [response.data[0]];
          user.push(value);
          this.$http
            .put('/users/togglenotifications', user)
            .then(() => {
              this.showNotificationDialog = false;
              this.$store.commit('user/setUserToggleNotifications', value, {
                root: true,
              });
            })
            .catch((err) => {
              console.error(err);
              $EventBus.$emit('message', {
                type: 'error',
                text: "Impossibile aggiornare i metadati dell'utente",
              });
            });
        })
        .catch((err) => {
          console.error(err);
          $EventBus.$emit('message', { type: 'error', text: "Impossibile recuperare l'utente" });
        });
    },
    deleteNotification(selected_notification, flag) {
      let stored_notification = this.$store.state.user.user_notifications;
      let filtered_array = [];
      if (!flag) {
        filtered_array = _.filter(stored_notification, (el) => {
          return el != selected_notification;
        });
      }
      // aggiorno lo store per non dover aggiornare la pagina ed avere un feedback immediato.
      this.$store.commit('user/setUserNotifications', filtered_array, {
        root: true,
      });
      // aggiorno auth0
      this.updateNotification(filtered_array);
    },
    updateNotification(notification) {
      this.$http
        .get('/users/email/' + this.$user.email)
        .then((response) => {
          const user = [response.data[0]];
          user.push(notification);
          this.$http
            .put('/users/updatenotification', user)
            .then(() => {})
            .catch((err) => {
              console.error(err);
              $EventBus.$emit('message', {
                type: 'error',
                text: "Impossibile aggiornare i metadati dell'utente",
              });
            });
        })
        .catch((err) => {
          console.error(err);
          $EventBus.$emit('message', { type: 'error', text: "Impossibile recuperare l'utente" });
        });
    },
    toggleLanguage() {
      // Logica per il cambio lingua
      this.$i18n.locale = !this.selectedLanguage ? 'it' : 'en';
    },
    resetPassword() {
      this.$http({
        method: 'get',
        url: '/resetpassword?email=' + this.$user.email,
      })
        .then((response) => {
          $EventBus.$emit('message', {
            type: 'success',
            text: "Ti abbiamo appena inviato un'e-mail per reimpostare la tua password.",
          });
        })
        .catch((err) => {
          console.log('reset password error', err);
          $EventBus.$emit('message', { type: 'error', text: 'Impossibile resettare la password' });
        });
    },
    getSheetId(url) {
      let splitted = url.split('/');
      return splitted[5];
    },
    startDownload() {
      this.showDialog = false; // se il dialog è visibile chiudilo
      let sheet_url = null;
      let lang = null;
      _.forEach(this.personalTenants, (tenant) => {
        if (tenant.i18n_name[tenant.default_lang] === this.tenantName) {
          sheet_url = tenant.sheet;
          lang = tenant.default_lang;
        }
      });
      const gsheet = this.getSheetId(sheet_url);
      this.showProgress = true;
      axios({
        url: 'https://cv.manifest.science/?lang=' + lang + '&gsheet=' + gsheet,
        method: 'GET',
        responseType: 'blob', // Imposta il tipo di risposta come blob
      })
        .then((response) => {
          $EventBus.$emit('message', {
            type: 'success',
            text: 'Your download is complete!',
          });
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'CV-' + this.tenantName + '.pdf');
          document.body.appendChild(link);
          link.click();
          this.showProgress = false;
        })
        .catch((error) => {
          console.error('Errore durante il download del PDF:', error);
          this.showProgress = false;
          $EventBus.$emit('message', {
            type: 'error',
            text: '500 Server error: Cannot download your CV. Try again later.',
          });
        });
    },
    downloadCV() {
      let array = [];
      let array2 = [];
      _.forEach(this.allTenants, function (tenant) {
        if (tenant.flavor === 'personal') {
          array.push(tenant.i18n_name[tenant.default_lang]);
          array2.push(tenant);
        }
      });
      this.personalTenantsName = array;
      this.personalTenants = array2;
      if (this.personalTenantsName.length == 1) {
        this.startDownload();
      } else if (this.personalTenantsName.length == 0) {
        $EventBus.$emit('message', {
          type: 'error',
          text: 'Tenants not found',
        });
      } else {
        this.showDialog = true;
      }
    },
  },
};
</script>

<style scoped>

.f-grow-1 {
  flex-grow: 1;
}

.align-center{
  align-content: center;
} 

.justify-space-evenly{
  justify-content: space-evenly;
}

.items-center{
  justify-items: center;
}
.flex {
  display: flex;
}

.flex-wrap {
  flex-wrap: wrap;
}

.name-title-size {
  font-size: 2.5rem;
}
.char-limit {
  width: 60ch;
}

hr {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.paragraph {
  margin: 1rem;
  margin-left: 0;
}

.language-switch {
  display: flex;
  align-items: center;
  width: fit-content;
  height: fit-content;
}

.label-it {
  margin-right: 8px;
}

.switch-container {
  margin-right: 8px;
}

.label-en {
  margin-left: 8px;
}

.font-subtitle {
  font-size: medium;
  font-weight: bold;
}

.white-box {
  width: 100%;
  padding: 2rem;
}
</style>
